import encHex from 'crypto-js/enc-hex'
import MD5 from 'crypto-js/md5'

/**
 * Gera uma cor OKLCH baseada em uma string com controle de luminosidade
 * OKLCH oferece melhor controle perceptual de cor e luminosidade
 * @param str - String base para gerar a cor
 * @param isDarkMode - Se true, ajusta luminosidade para modo escuro
 */
export function generateColor(str: string) {
    const hash = MD5(str)
    const hex = hash.toString(encHex)

    // Gera hue (0-360) a partir do hash
    const hueValue = parseInt(hex.slice(0, 8), 16)
    const hue = hueValue % 360

    // Gera chroma (0-0.37 para cores vibrantes mas não saturadas demais)
    const chromaValue = parseInt(hex.slice(8, 16), 16)
    const chroma = 0.15 + (chromaValue % 100) / 450 // Range: 0.15-0.37

    return {
        light: `oklch(0.6 ${chroma.toFixed(3)} ${hue})`,
        dark: `oklch(0.7 ${chroma.toFixed(3)} ${hue})`,
    }
}
